<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div>
    <app-input-text [control]="form.get('first_name')" name="contact_first_name" [autoFocus]="true"></app-input-text>
    <app-input-text [control]="form.get('last_name')" name="contact_last_name"></app-input-text>
    @if (showMail) {
      <app-input-text [control]="form.get('email')" name="contact_email"></app-input-text>
    }
    @if (showInvite) {
      <app-input-checkbox [control]="form.get('invite')" name="contact_invite" [text]="'select_invoice_contact_send_invite' | i18next"></app-input-checkbox>
    }
  </div>
  <div class="d-flex justify-content-end mt-3">
    <ng-content></ng-content>
    <app-button-submit [invalid]="form.invalid" [label]="submitButtonLabel"></app-button-submit>
  </div>
</form>
